var jq = jQuery.noConflict();
jq(document).ready(function() {
    //start of external link popup
    var targetUrl = ''; 
    jq('a').on('click', function(event) {
        var url = jq(this).attr('href');
        var linkHostname = new URL(url).hostname; 
        var currentHostname = window.location.hostname;

        // Check if the link is external
        if (linkHostname !== currentHostname) {
            event.preventDefault(); 
            targetUrl = url; 
            showModal(); 
        }
    });

    function showModal() {
        jq('#external-link-popup').fadeIn(); // Show modal with fade-in effect
        trapFocus(); // Activate focus trap
    }

    function hideModal() {
        jq('#external-link-popup').fadeOut();
        targetUrl = '';
        jq(document).off('keydown', trapFocus);
    }

    jq('#external-link-popup .continue-btn').on('click', function() {
        window.location.href = targetUrl;
    });

    jq('#external-link-popup .cancel-btn').on('click', function() {
        hideModal();
    });
    
    // Click outside the modal should not close or interact with anything behind it
    jq(window).on('click', function(event) {
        if (!jq(event.target).closest('#external-link-popup .modal-content').length) {
            event.stopPropagation(); 
        }
    });

    function trapFocus() {
        var focusableElements = jq('#external-link-popup ').find('button');
        var firstElement = focusableElements.first();
        var lastElement = focusableElements.last();

        firstElement.focus();

        jq(document).on('keydown', function(e) {
            if (e.key === 'Tab') {
                if (e.shiftKey) { // If Shift + Tab is pressed
                    if (document.activeElement === firstElement[0]) {
                        e.preventDefault();
                        lastElement.focus(); 
                    }
                } else {
                    if (document.activeElement === lastElement[0]) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        });
    }
    //end of external link popup
});